// @flow
import React from "react";

import DynamicSelectProvider from "./DynamicSelectProvider";
import DynamicSelectTariffs from "./DynamicSelectTariffs";

type Props = {|
  input: {
    value: number,
  },
|};
//Components ready to be used by reduxform
export const RFDynamicSelectProvider = (props: Props) => <DynamicSelectProvider value={props.input.value} {...props} />;

export const RFDynamicSelectTariffs = (props: Props) => <DynamicSelectTariffs value={props.input.value} {...props} />;
